<template>
  <v-app :class="{'home-page' : isHome}">
    <router-view name="header-router"></router-view>
    <v-content>

      <router-view ></router-view>
    </v-content>
    <router-view name="footer-router">
      <label v-if="showFooterSlot" class="hidden-md-and-down mt-1">
        GET IN TOUCH
      </label>
    </router-view>
  </v-app>
</template>

<script>

export default {
  name: 'app',
    components: {
    },
  data(){
    return{
      isHome: true,
      showFooterSlot: true,
    }
  },
  watch:{
    '$route' (to, from){
      if(to.path.includes('/orgWorkSpace')){
        this.isHome = false;
        this.showFooterSlot = false;
      }
      else {
        this.isHome = true;
        this.showFooterSlot = true;
      }
    }
  }
}
</script>

<style scoped>
  /*@import './static/fonts/style.css';*/

  #app {
    font-family: Helvetica, 'Avenir', Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    background-color: white;
  }
  .home-page {
    background-color: #EDF9FF !important;
  }

</style>

<style>
  label{
    margin: 0px !important;
  }

  a:hover {
    /* Applies to links under the pointer */
    text-decoration:  none !important;
    font-weight:      bold;
    color:            #fff;
  }

  /* bug on fluid not getting set with max-width hence setting it manually*/
  .container--fluid{
    height: 100% !important;

  }

  .v-sheet--offset {
    top: -24px;
    position: relative;
  }

</style>
